import React, { Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Dashboard/Dashboard.css";


import { Button } from "reactstrap";
import Header from "../../DefaultLayout/Header";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";


import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";


const ConfirmationCard = (props) => {
  const { frontLabelsName } = props.label;
  const history = useHistory();
  const isAuth = props.auth.isAuthenticated;
  const acceptHandler = () => {
    history.push("/applied-properties");
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
      {isAuth ? <LoggedHeader /> : <Header />}
        {/* <NavbarSection /> */}
        <DashboardNavbar/>

      </Suspense>
      <div className=" mb-5 pt-5">
        <div
          className="row "
          style={{ display: "flex", justifyContent: "center",width:"100%" }}
        >
          <div className="col-lg-7 col-md-10 col-11 ">
            <div className="register-non-user11 register-body">
              <h6>
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_thankyou_for_your_confirmation"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_thankyou_for_your_confirmation"
                      )[0]["value"] || "lbl_thankyou_for_your_confirmation"
                    : "lbl_thankyou_for_your_confirmation"
                  : "lbl_thankyou_for_your_confirmation"}
              </h6>
              <h6>
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) =>
                        e.key ==
                        "lbl_you_have_successfully_accepted_confirmation_message"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) =>
                          e.key ==
                          "lbl_you_have_successfully_accepted_confirmation_message"
                      )[0]["value"] ||
                      "lbl_you_have_successfully_accepted_confirmation_message"
                    : "lbl_you_have_successfully_accepted_confirmation_message"
                  : "lbl_you_have_successfully_accepted_confirmation_message"}
              </h6>
              {/* <div className="otp-box-rg-new-non11"> */}
              <div className=" d-flex justify-content-around mt-5">
                <Button onClick={acceptHandler} className="button-get-access">
                  {" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_close").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_close")[0][
                          "value"
                        ] || "lbl_close"
                      : "lbl_close"
                    : "lbl_close"}
                </Button>
              
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(ConfirmationCard);
